import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 12h-2","key":"svg-0"}],["path",{"d":"M2 9h4","key":"svg-1"}],["path",{"d":"M2 15h4","key":"svg-2"}],["path",{"d":"M5 19c1.778 -4.667 1.778 -9.333 0 -14","key":"svg-3"}],["path",{"d":"M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14","key":"svg-4"}],["path",{"d":"M16 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-5"}]]

const IconLogicXnor = createReactComponent('outline', 'logic-xnor', 'LogicXnor', __iconNode);

export default IconLogicXnor;